import { Loading3QuartersOutlined } from "@ant-design/icons";
import { Alert, Button, Form, Spin } from "antd";
import { useForm } from "react-hook-form";
import { DateField } from "../../../../../../atoms/FormFields";
import WarningIcon from "../../../../../../atoms/CustomIcons/WarningIcon";

const antIcon = <Loading3QuartersOutlined spin />;

interface PropsType {
  onClose: () => void;
  title: string;
  heading: string;
  paragraph?: string | JSX.Element;
  btnText: string;
  btnApi: () => void;
  loading: boolean;
  secondBtnText?: string;
  isArchivePopup?: boolean;
}

interface FormValues {
  proposal_amount_exceeds: string;
  effectiveDate?: string;
}

const SpecifyEffectiveDatePopup = (props: PropsType) => {
  const { onClose, heading, paragraph, btnText, btnApi, loading } = props;

  const onCloseHandler = () => {
    onClose();
  };

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<FormValues>();
  const onSubmit = (data: FormValues) => {
    console.log("Form Data:", data);
  };

  return (
    <Spin indicator={antIcon} size="large" spinning={loading}>
      <div className="modalWrapper" style={{ padding: "16px" }}>
        <Form
          layout="vertical"
          onFinish={handleSubmit(onSubmit)}
          onKeyDown={(e) => {
            if (e.key === "Enter") e.preventDefault();
          }}
        >
          <div className="modal_header">
            <div className="title" style={{ textAlign: "center" }}>
              <h2 style={{ marginBottom: "12px" }}> {heading} </h2>
            </div>
          </div>

          <div className="modal_content">
            <p
              style={{
                color: "#474C4D",
                marginBottom: "32px",
                fontSize: "16px",
                lineHeight: "24px",
                textAlign: "center",
              }}
            >
              {paragraph}
            </p>

            <DateField
              defaultValue=""
              fieldName="effectiveDate"
              label="Date effective"
              control={control}
              iProps={{
                placeholder: "MM/DD/YYYY",
              }}
              tooltipTitle="Date effective"
              isRequired
              rules={{
                required: "Date effective is required.",
              }}
              validate={errors.effectiveDate && "error"}
              validMessage={
                errors.effectiveDate && errors.effectiveDate?.message
              }
            />

            <Alert
              message={
                <>
                  <h4> Impact on existing routes </h4>
                  <p>
                    Routes scheduled after the effective date will be updated
                    automatically. We recommend applying changes from a future
                    date with no scheduled work.
                  </p>
                </>
              }
              type="warning"
              style={{ marginTop: "32px" }}
              showIcon
              icon={<WarningIcon />}
              className="alert_info_box"
            />
          </div>

          <div
            className="modal_footer"
            style={{
              margin: "0 auto",
              paddingTop: "32px",
              justifyContent: "center",
            }}
          >
            <Button
              htmlType="button"
              className="outlined-btn"
              type="default"
              size="large"
              onClick={onCloseHandler}
            >
              Cancel
            </Button>

            <Button
              htmlType="button"
              className="mint-btn"
              type="primary"
              size="large"
              onClick={btnApi}
              loading={loading}
            >
              {btnText}
            </Button>
          </div>
        </Form>
      </div>
    </Spin>
  );
};

export default SpecifyEffectiveDatePopup;
